<template>
  <div class="wrapper">
    <!-- 单独发送小红花 -->
    <el-dialog
      :title="student_info.name"
      :visible.sync="send_flower_once_dia"
      width="30%"
      custom-class="studen_list_dia"
    >
      <div class="">
        <div style="">
          <div style="margin: 10px 0">奖扣小红花数量：</div>
          <el-input-number size="" v-model="flower_num_once"></el-input-number>
        </div>
        <div style="">
          <div style="margin: 10px 0">奖扣理由：</div>
          <el-input
            v-model="flower_once_reason"
            placeholder="请输入奖扣理由"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="send_flower_once_dia = false">取 消</el-button>
        <el-button type="primary" @click="send_flower_once_confirm()"
          >发 送</el-button
        >
      </span>
    </el-dialog>

    <div class="head">
      <div @click="$router.go(-1)">
        <img src="../../assets/images/course_2.0/返回.png" alt="" />
      </div>
      <div class='item_content_item_title'>{{ student_name }}的作业报告</div>
      <div class="flex-row-center">
        <!-- <div class="head_set_flower">
          <div @click="send_flower_once()">奖扣小红花</div>
        </div> -->
      </div>
    </div>
    <div class="report_content">
      <div>
        <div class="item_title_detail">
          <div>作业概况</div>
        </div>
        <div class="item_content">
          <div class="item_content_item">
            <div class="item_content_item_title">
              总分：{{ homeworkDetail.precision_num }}分
            </div>
            <div class="item_content_item_data">
              <div>
                高于平均分{{
                  (
                    Number(homeworkDetail.precision_num) -
                    diff.avg_precision_num
                  ).toFixed(1)
                }}分
              </div>
            </div>
          </div>
          <div class="item_content_item">
            <div class="item_content_item_title">
              用时：{{ homeworkDetail.homework_total_time }}秒
            </div>
            <div class="item_content_item_data">
              <div>
                快于平均用时{{
                  (
                    Number(homeworkDetail.homework_total_time) -
                    diff.avg_homework_total_time
                  ).toFixed(1)
                }}秒
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <!-- 成绩 -->
        <div class="item_title_detail">
          <div>习题分析</div>
          <div class="flex-center">
            <el-checkbox @change="onChange" v-model="checked"
              >只显示错题</el-checkbox
            >
          </div>
        </div>
        <div class="item_result" v-if="homeworkDetail">
          <div
            class="item_list"
            v-for="(item, index) in homeworkDetail.topicList"
            :key="index"
          >
            <div class="flex-row">
              <span>{{ index + 1 }}.</span>
              <div v-html="item.content"></div>
            </div>
            <!-- 主观题 -->
            <div
              class="answerBox flex-col"
              v-if="!item.is_unique || Array.isArray(item.answer)"
            >
              <div class="flex-row-v-center" v-if="!Array.isArray(item.answer)">
                <span>正确答案：</span>
                <div v-html="item.answer"></div>
              </div>
              <div class="flex-row-v-center" v-else>
                <span>正确答案：</span>
                <div v-for="(data, index) in item.answer" :key="index">
                  <div style="margin-right: 20px" v-html="data"></div>
                </div>
              </div>
              <div class="flex-row-v-center">
                <span>学生答案：</span>
                <div class="imgageBox">
                  <div
                    v-for="(url, index_url) in item.student_answer"
                    :key="index_url"
                  >
                    <el-image
                      v-if='item.student_answer_small[index_url]'
                      :src="
                        url.thumbnail ||
                        (item.student_answer_small[index_url]
                          ? item.student_answer_small[index_url].image
                          : url.image)
                      "
                    ></el-image>
                  </div>
                </div>
              </div>
              <div class="flex-row answerFooter">
                <div class="marginR">该题得分：{{ item.score }}分</div>
                <div class="marginR">
                  答题时间：{{ item.tiku_total_time }}秒
                </div>
                <div class="marginR">
                  全班得分率：{{
                    (
                      (diff.avg_score_per_tiku[item.path] / item.src_score) *
                      100
                    ).toFixed(1)
                  }}%
                </div>
              </div>
            </div>
            <!-- 客观题 -->
            <div class="answerBox flex-col" v-else>
              <div class="flex-row">
                <div class="flex-row answerItem">
                  <span>正确答案：</span>
                  <div style="color:#67c23a">{{item.answer}}</div>
                </div>
                <div class="flex-row answerItem">
                  <span>学生答案：</span>
                  <div v-if='item.student_answer==item.answer' style="color:#67c23a">{{ item.student_answer }}</div>
                  <div v-else style="color:#f56c6c">{{item.student_answer}}</div>
                </div>
              </div>
              <div class="flex-row answerFooter">
                <div class="marginR">该题得分：{{ item.score }}分</div>
                <div class="marginR">
                  答题时间：{{ item.tiku_total_time }}秒
                </div>
                <div class="marginR">
                  全班得分率：{{
                    (
                      (diff.avg_score_per_tiku[item.path] / item.src_score) *
                      100
                    ).toFixed(1)
                  }}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>
<script>
import echarts from "echarts";
import bus from "../../plugins/Bus";
// import app_richText from "../../components/rich/app_richText.vue";
import ifram from "../../components/ifarm/ifarm";
import previewData from "../../components/common_module/preview_data.vue";
export default {
  components: { ifram, previewData },
  data() {
    return {
      student_name: "",
      student_uuid: "",
      homeworkDetail: "",
      diff: "",
      checked: false,
      summary: {
        un_submit_list: [],
        un_correction_list: [],
        overtime_list: [],
        precision_statistics_list: [],
        submit_ratio: 0,
        correction_ratio: 0,
        verage_time: 0,
      }, //学生得分情况
      achievementList: [],
      flower_once_reason: "",
      student_info: "",
      send_flower_once_dia: false,
      flower_num_once: 0,
      student_arr: [], //学生得分情况 暂时没用
      show_type: 1,
      topic_detail_list: [],
      un_submit_flower: -1,
      excellent_flower: 3,
      fine_flower: 2,
      pass_flower: 1,
      fail_flower: 0,
    };
  },
  mounted() {
    this.student_name = this.$route.query.student_name;
    this.student_uuid = this.$route.query.student_uuid;
    this.get_correct_work();
  },
  methods: {
    onChange() {
      if (this.checked) {
        let arr = []
        for (let i in this.homeworkDetail.topicList) {
          if (
            this.homeworkDetail.topicList[i].src_score !=
            this.homeworkDetail.topicList[i].score
          ) {
            arr.push(this.homeworkDetail.topicList[i])
          }
        }
        this.homeworkDetail.topicList = arr
        console.log(this.homeworkDetail)
      } else {
        this.get_correct_work();
      }
    },
    // 单独发送小红花
    send_flower_once(item) {
      // console.log(item)
      this.send_flower_once_dia = true;
      this.student_info = item;
      this.flower_num_once = 0;
      this.flower_once_reason = "";
    },
    send_flower_once_confirm() {
      let formData = {};
      formData.scene_name = "homework_usages";
      formData.scene_id_or_uuid = this.$route.query.homework_src_uuid;
      formData.student_list = [
        {
          reason: this.flower_once_reason
            ? this.flower_once_reason
            : "作业：" + this.$route.query.homework_title,
          student_uuid: this.student_info.student_uuid,
          score: this.flower_num_once,
        },
      ];
      this.axios.post("/school/coin_log/send", formData).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.send_flower_once_dia = false;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
        // console.log(res)
      });
    },
    //获取学生答题情况
    get_correct_work() {
      var formData = new FormData();
      formData.append("batch_id_by_class", this.$route.query.batch_id_by_class);
      formData.append("usages_id", this.$route.query.usages_id);

      this.axios
        .post(`/school/Homework_Usages/homeworkUsagesSingleDetail`, formData)
        .then((res) => {
          if (res.data.code == 1) {
            this.homeworkDetail = res.data.data.data;
            this.diff = res.data.data.diff;
            this.homeworkDetail.student_usages_json = JSON.parse(
              this.homeworkDetail.student_usages_json
            );
            let topicList = [];
            for (let index in this.homeworkDetail.student_usages_json) {
              topicList = topicList.concat(
                this.homeworkDetail.student_usages_json[index].topicList
              );
            }
            this.homeworkDetail.topicList = topicList;
            for (let i in this.homeworkDetail.topicList) {
              if (Array.isArray(this.homeworkDetail.topicList[i].score)) {
                let num = 0;
                for (let a in this.homeworkDetail.topicList[i].score) {
                  num = num + Number(this.homeworkDetail.topicList[i].score[a]);
                }
                this.homeworkDetail.topicList[i].score = num;
                this.homeworkDetail.topicList[i].answer = JSON.parse(
                  this.homeworkDetail.topicList[i].answer
                );
              }
            }
            console.log(this.homeworkDetail, this.diff);
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
  },

  beforeDestroy() {},
};
</script>

<style >
.flower_dia .el-dialog__footer {
  text-align: center;
}
.flower_dia {
  border-radius: 18px;
}
.studen_list_dia {
  border-radius: 18px;
}
.flower_dia .el-dialog__footer .el-button {
  margin: 0 40px;
}
.grade_detail_item .el-progress-circle {
  width: 142px !important;
  height: 142px !important;
}
.el-table .warning-row {
  background: #f0f9eb;
}
</style>
<style scoped>
.wrapper {
  background: #f2f9ff;
  height: calc(100vh - 142px);
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  /* margin: 0 360px; */
}
.wrapper_pad {
  background: #f2f9ff;
  height: calc(100vh - 32px);
  padding: 16px;
  /* box-sizing: border-box; */
  display: flex;
  flex-direction: column;
}
.head {
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #69b4ff;
  margin-bottom: 20px;
}
.head img {
  display: block;
  cursor: pointer;
  width: 24px;
  height: 20px;
}
.head_set_flower > div {
  /* margin-left: auto; */
  height: 40px;
  border: 2px solid #ffffff;
  cursor: pointer;
  background: radial-gradient(circle, #69b4ff 0%, #7dc6ff 100%);
  box-shadow: 0px 0px 4px 0px #2087ec;
  border-radius: 14px;
  line-height: 40px;
  padding: 0 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.report_content {
  /* background: red; */
  flex: 1;
  padding: 0 20px;
  overflow: auto;
}
.homework_title {
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  display: flex;
  margin-bottom: 20px;
}
.homework_title > div:nth-of-type(2) {
  background: #ffffff;
  border-radius: 20px 0px 20px 2px;
  margin-left: 20px;
  padding: 0 20px;
  min-width: 150px;
}
.item_title_detail {
  display: flex;
}
.item_title_detail > div:nth-of-type(2) {
  cursor: pointer;
  color: #69b4ff;
  margin-left: 20px;
}
.item_content {
  background: #ffffff;
  border-radius: 46px 12px 46px 12px;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.item_content_item {
  background: #f4faff;
  border-radius: 46px 12px 46px 12px;
  width: 25%;
  font-size: 12px;
  color: #999999;
  padding: 16px;
  line-height: 30px;
}
.item_content_item_title {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.item_content_item_data {
  display: flex;
}
.item_content_item_data > div:nth-of-type(2) {
  color: #69b4ff;
  margin-left: 20px;
}
.item_result {
  background: #ffffff;
  border-radius: 46px 12px 46px 12px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.item_list {
  padding: 25px;
}
.result_l {
}
#chartPie {
  width: 500px !important;
  height: 600px !important;
}
.result_r {
  flex: 1;
  border: 2px solid #69b4ff;
  border-radius: 12px 12px 12px 12px;
  margin: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.result_r_head {
  height: 30px;
}
.result_r_head {
  display: flex;
  justify-content: space-around;
  padding: 10px 30px;
  cursor: pointer;
}
.student_arr_type_active {
  color: #69b4ff;
}
.result_r_content {
  flex: 1;
  overflow: auto;
  padding: 10px 30px;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}
.result_r_contentBox {
  margin: 20px 40px;
  position: relative;

  border-radius: 26px 26px 26px 26px;
}
.result_r_content_item {
  background: #f4faff;
  border-radius: 26px 0px 0px 26px;
  padding: 10px 40px 10px 20px;
  height: 30px;
  line-height: 30px;
}
.scoreBox {
  width: 60px;
  height: 60px;
  border: 5px solid #69b4ff;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.scoreNum {
  font-size: 20px;
  /* color: #69b4ff; */
}
.student_list_dia {
  margin-top: 20px;
}
.student_list_dia {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.student_list_dia_item {
  height: 38px;
  background: #f4faff;
  border-radius: 20px 0px 20px 2px;
  padding: 0 20px;
  margin: 0 20px 20px 0;
  line-height: 38px;
}
.grade_detail {
  height: 424px;
  background: #ffffff;
  border-radius: 46px 12px 46px 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.grade_detail > div:nth-of-type(1) {
  height: 28px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 28px;
  margin: 20px;
}
.grade_detail_itemBox {
  width: 100%;
  flex: 1;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  box-sizing: border-box;
}
.grade_detail_item {
  width: 142px;
  cursor: pointer;
  margin-right: 25px;
  margin-bottom: 20px;
}

/* .grade_detail_item_circle{
        height: 82px;
        width: 82px;
        border-radius: 50%;
        line-height: 82px;
        text-align: center;
        background: #F3F3F3;
    } */
.grade_detail_item > div:nth-of-type(2) {
  text-align: center;
}
.achievementListBox {
  box-sizing: border-box;
  height: 100%;
  width: 90%;
  margin: 20px;
  overflow: auto;
  border: 1px solid #ebeef5;
}
.achievementListItem {
  width: 100px;
  height: 40px;
  display: inline-block;
  line-height: 40px;
  text-align: center;
}
.achievementListBoxHead {
  white-space: nowrap;
}
.achievementListBoxHeadActive {
  background: #edf4fa;
}
.marginB {
  margin-bottom: 20px;
}
.result_r_content {
  flex: 1;
  overflow: auto;
  padding: 10px 20px;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}
.result_r_contentBox {
  margin: 40px 60px;
  position: relative;
  border-radius: 26px 26px 26px 26px;
  position: relative;
}
.result_r_content_item {
  background: #f4faff;
  border-radius: 26px 0px 0px 26px;
  padding: 10px 40px 10px 20px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}
.scoreBox {
  width: 60px;
  height: 60px;
  border: 5px solid #69b4ff;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.scoreNum {
  font-size: 20px;
  /* color: #69b4ff; */
}
.indexNum {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  position: absolute;
  left: -20px;
  background: #ffffff;
}
.color1 {
  color: #69b4ff !important;
}
.color2 {
  color: #ff9b36 !important;
}
.color3 {
  color: #e37cfd !important;
}
.color4 {
  color: #fe3844 !important;
}
.scoreBox2 {
  width: 60px;
  height: 60px;
  border: 5px solid #ff9b36;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.scoreBox3 {
  width: 60px;
  height: 60px;
  border: 5px solid #e37cfd;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.scoreBox4 {
  width: 60px;
  height: 60px;
  border: 5px solid #fe3844;
  border-radius: 100%;
  background: #ffffff;
  position: absolute;
  right: -50px;
}
.answerBox {
  background: #f2f9ff;
  padding: 10px 20px;
}
.answerItem {
  background: #ffffff;
  padding: 10px 50px;
  margin-right: 30px;
  border-radius: 50px;
  margin-bottom: 20px;
}
.answerFooter {
  padding: 10px 20px;
}
.marginR {
  margin-right: 50px;
  color: #333333;
}
p {
  padding: none;
  margin: none;
}
.imgageBox {
  width: 800px;
  /* height: 200px; */
}
</style>